class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.refreshing = false;
    this.suppressNextOpenRefresh = false;
  }

  connectedCallback() {
    this.header = document.querySelector("sticky-header");
    this.drawer = document.querySelector("cart-drawer");

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    const detailsEl = this.drawer?.querySelector("details");
    if (detailsEl) {
      detailsEl.addEventListener("toggle", () => {
        if (!detailsEl.open || !this.loaded) return;
        if (this.suppressNextOpenRefresh) {
          this.suppressNextOpenRefresh = false;
          return;
        }
        this.refresh();
      });
    }

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && this.loaded) this.refresh();
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.refresh().then(() => {
      this.loaded = true;
      document.dispatchEvent(new CustomEvent("cartdrawer:opened"));
    });
  }

  refresh() {
    if (this.refreshing) return Promise.resolve();
    this.refreshing = true;
    return fetch(this.dataset.url, { cache: "no-store" })
      .then((response) => response.text())
      .then((html) => {
        const miniCartEl = document.getElementById("mini-cart");
        if (miniCartEl) {
          miniCartEl.innerHTML = this.getSectionInnerHTML(html, ".shopify-section");
        }
        this.notifyExternalScripts();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.refreshing = false;
      });
  }

  notifyExternalScripts() {
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { source: "cart-drawer" } }));
    document.dispatchEvent(new CustomEvent("cart:refreshed"));
    try { window.wsg?.refresh?.(); } catch (_) {}
    try { window.WSG?.refresh?.(); } catch (_) {}
    try { window.BSS_B2B?.refresh?.(); } catch (_) {}
    try { window.wholesale?.refresh?.(); } catch (_) {}
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement.hasAttribute("open")) return;
    this.suppressNextOpenRefresh = true;
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      }
    });

    this.notifyExternalScripts();
    this.open();

    fetch("/cart.json", { cache: "no-store" })
      .then((response) => response.json())
      .then((cart) => {
        if (cart.items_subtotal_price < 7500) return;
        const isFreeshipApplied = cart.discounts.some(
          (discount) => discount.code === "FREESHIP"
        );
        if (isFreeshipApplied) return;

        fetch("/discount/FREESHIP")
          .then((response) => {
            if (!response.ok) {
              console.error("Failed to apply FREESHIP discount.");
              return;
            }
            const sections = this.getSectionsToRender().map((s) => s.section);
            const sectionsUrl = `${window.location.pathname}?sections=${sections.join(",")}`;
            fetch(sectionsUrl, { cache: "no-store" })
              .then((sectionsResponse) => sectionsResponse.json())
              .then((updatedSections) => {
                this.getSectionsToRender().forEach((section) => {
                  if (
                    document.getElementById(section.id) &&
                    updatedSections[section.section]
                  ) {
                    document.getElementById(section.id).innerHTML =
                      this.getSectionInnerHTML(
                        updatedSections[section.section],
                        section.selector
                      );
                  }
                });
                this.notifyExternalScripts();
              });
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("mini-cart", MiniCart);
